import storage from '../store';
export default function isDevelopment(){
    return storage.get('__mode__') === 'true';
}








